import { useEffect } from "react";
import { useAppSelector } from "@builder/store/store";

const useBuilderGlobalColors = () => {
    const globalColors = useAppSelector(state => state.builder.build.extraAttributes?.buildGlobalColors);
    const buildSettingsKey = useAppSelector(state => state.buildSettingsKey);

    useEffect(() => {
        globalColors?.forEach(({ id, color }) => {
            document.documentElement.style.setProperty(
                `--${id}`,
                buildSettingsKey?.[color]?.placeholder ? buildSettingsKey[color].placeholder || "" : color
            );
        });

        return () => {
            globalColors?.forEach(({ id }) => {
                document.documentElement.style.removeProperty(`--${id}`);
            });
        };
    }, [globalColors, buildSettingsKey]);
};

export default useBuilderGlobalColors;
